export default "__VITE_ASSET__$$s8$QhJ__";